import { inject, InjectionToken, type Provider } from '@angular/core';
import { provideTranslocoScope, TranslocoService } from '@jsverse/transloco';

/**
 * It's necessary because if we solve it through inheritance, it won't find the string type with inject()
 */
export type I18nInjectionToken = InjectionToken<string> & { scope: string };

export function buildI18nInjectionToken(scope: string): I18nInjectionToken {
  const token = new InjectionToken<string>(scope);
  Object.defineProperty(token, 'scope', {
    value: scope,
    writable: false,
  });

  return token as I18nInjectionToken;
}

export function provideI18nScope(...scopeInjectionTokens: I18nInjectionToken[]): Provider[] {
  return scopeInjectionTokens
    .map(scopeInjectionToken => {
      const scope = scopeInjectionToken.scope;
      return [
        provideTranslocoScope(scope),
        {
          provide: scopeInjectionToken,
          useFactory: (): string => {
            const translocoService = inject(TranslocoService);
            const activeLang = translocoService.getActiveLang();
            translocoService.load(`${scope}/${activeLang}`).subscribe();
            return scope;
          },
        },
      ];
    })
    .flat();
}
